module.exports = __webpack_public_path__ + "img/positivo_1.785bae90.svg";